import React from "react";
import SurveyRadarChart from "./SurveyRadarChart";
import { getScore } from "../../../helpers/getScore";

const SurveyDtlsItem = ({ survey, question, id }) => {
  return (
    <div style={{ padding: 15, borderBottom: "0.5px solid gray" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row"
        }}
      >
        <div>
          <div style={{ display: "flex" }}>
            <h3 style={{ width: 50 }}>Q{id + 1}</h3>
            <p>{question.qn}</p>
          </div>

          <div style={{ marginLeft: 50 }}>
            {id === 0 ? (
              <div style={{ display: "flex" }}>
                <img
                  alt=""
                  style={{ width: 150, height: 200, objectFit: "contain" }}
                  src={survey.answers[id + 1]}
                />
                <div
                  style={{ marginLeft: 250, marginTop: -50, height: "50%" }}
                ></div>
              </div>
            ) : (
              <p>
                {survey.answers[(id + 1).toString()] ?? 0}
                {question.ansType == "slider" && "/10"}
              </p>
            )}
          </div>
        </div>
        <div style={{marginLeft:10}} >
          <p style={{color:'green'}} >{getScore(id, survey.answers[(id + 1).toString()])}</p>
        </div>
      </div>
    </div>
  );
};

export default SurveyDtlsItem;
